import { useState, useEffect } from 'react';

const useCountUpScore = (targetScore) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (targetScore === 0) {
      setCount(0);
      return;
    }

    const duration = 500;
    const incrementStep = Math.max(1, Math.ceil(targetScore / (duration / 10)));
    const stepTime = duration / (targetScore / incrementStep);

    const timer = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount + incrementStep >= targetScore) {
          clearInterval(timer);
          return targetScore;
        } else {
          return prevCount + incrementStep;
        }
      });
    }, stepTime);

    return () => clearInterval(timer);
  }, [targetScore]);

  return count;
};

export default useCountUpScore;
